// @flow

import React, {useCallback} from 'react';
import AppPickerUtil from '../../../../utils/AppPicker/AppPickerUtil';
import PlanModalContentScss from './PlanModalContent.scss';

export default () => {
	const viewYourPlanModalData = AppPickerUtil.getViewYourPlanModalContent();
	const desktopAppsList = viewYourPlanModalData.desktopAppsList;
	const mobileAppsList = viewYourPlanModalData.mobileAppsList;
	const webAppsList = viewYourPlanModalData.webAppsList;

	const renderAppList = useCallback((appList, heading) => {
		if (appList && appList.length > 0) {
			return (
				<div className={PlanModalContentScss.viewYourPlanModalAppsList}>
					<div className={PlanModalContentScss.viewYourPlanModalListHeading}>
						{heading}
					</div>
					{appList.map(appName => <div key={appName}>{appName}</div>)}
				</div>
			);
		}
	}, []);

	return (
		<div className={PlanModalContentScss.viewYourPlanModalBody}>
			<div className={PlanModalContentScss.viewYourPlanModalDesc}>
				{viewYourPlanModalData.description.plaintext ? viewYourPlanModalData.description.plaintext : viewYourPlanModalData.description}
			</div>
			<div className={PlanModalContentScss.viewYourPlanModalApps}>
				{renderAppList(desktopAppsList, viewYourPlanModalData.desktopAppsSubheading)}
				{renderAppList(mobileAppsList, viewYourPlanModalData.mobileAppsSubheading)}
				{renderAppList(webAppsList, viewYourPlanModalData.webAppsSubheading)}
			</div>
		</div>
	);
};
